import { render } from "./AddPortalEmail.vue?vue&type=template&id=194ca4d4"
import script from "./AddPortalEmail.vue?vue&type=script&lang=js"
export * from "./AddPortalEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__